/// <amd-module name="Feed/Core/Redux/PerfTracker/PerfTrackerActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

export const enum PerfTrackerActionTypes {
    StartPerformanceTracking = "Feed/PerformanceTracking/Start",
    EndPerformanceTracking = "Feed/PerformanceTracking/End"
}

export const PerfTrackerActions = {
    startPerformanceTracking: (scenario: string) =>
        createAction(PerfTrackerActionTypes.StartPerformanceTracking, { scenario }),
    endPerformanceTracking: (scenario: string) =>
        createAction(PerfTrackerActionTypes.EndPerformanceTracking, { scenario })
};

export type PerfTrackerActions = ActionsUnion<typeof PerfTrackerActions>;
